import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import CheckIcon from '@mui/icons-material/Check'
import { Typography, Tooltip } from '@mui/material'

import { getEnevelopeCompletedBySelf, formatDate } from '@util/CommonServicess'

import classes from './EnevelopStatus.module.css'
import { colors } from '@theme/index'

interface EnevelopStatusProps {
    isAborted?: boolean
    isRejected?: boolean
    isCompleted?: boolean
    state: any
    publishDate: string
    id: string
}

const EnevelopStatus: React.FC<EnevelopStatusProps> = ({
    isAborted,
    isRejected,
    isCompleted,
    state,
    publishDate,
    id,
}) => {
    const { t } = useTranslation()

    const statusText = useMemo(() => {
        return isRejected
            ? t('global.rejected')
            : isAborted
            ? t('global.aborted')
            : isCompleted
            ? t('global.finalized')
            : getEnevelopeCompletedBySelf(state)
            ? t('global.pendingOthers')
            : t('global.pendingActions')
    }, [isRejected, isAborted, isCompleted, state, t])

    return (
        <div className={classes.statusContainer}>
            <Tooltip title={id}>
                {isAborted || isRejected ? (
                    <div className={classes.rejectedMark} style={{ backgroundColor: colors.dangerous }} />
                ) : isCompleted ? (
                    <div className={classes.chekMarkWrapper} style={{ backgroundColor: colors.primary }}>
                        <CheckIcon color="secondary" sx={{ fontSize: '12px' }} />
                    </div>
                ) : (
                    <div className={classes.pendingMark} style={{ borderColor: colors.primary }} />
                )}
            </Tooltip>
            <Typography
                sx={{
                    color: colors.info,
                    marginLeft: '5px',
                    fontWeight: '500',
                    maxWidth: {
                        lg: '100%',
                        xs: '200px',
                    },
                }}
            >
                {statusText}&nbsp;.
            </Typography>
            <Typography sx={{ color: colors.info, marginLeft: '5px', fontWeight: '500' }}>
                {formatDate(publishDate)}
            </Typography>
        </div>
    )
}

export default EnevelopStatus
